import store2 from 'store2';
import storeHelper from './storeHelper';

/**
 * Storage Auth that is used to save auth data.
 * @returns {store2} The function refer to https://www.npmjs.com/package/store2.
 */
const authStorage = storeHelper('auth');

/**
 * Storage kyc that is used to save kyc data.
 * @returns {store2} The function refer to https://www.npmjs.com/package/store2.
 */
const kycStorage = storeHelper('kyc');

/**
 * Storage community that is used to save community data.
 * @returns {store2} The function refer to https://www.npmjs.com/package/store2.
 */
const communityStorage = storeHelper('community');

/**
 * Storage community that is used to Mutual Fund data.
 * @returns {store2} The function refer to https://www.npmjs.com/package/store2.
 */
const mutualFundStorage = storeHelper('mutualFund');

/**
 * Storage trans that is used to save trans data.
 * @returns {store2} The function refer to https://www.npmjs.com/package/store2.
 */
const transactionStorage = storeHelper('trans');

/**
 * Storage generic that is used to save generic data.
 * @returns {store2} The function refer to https://www.npmjs.com/package/store2.
 */
const genericStorage = storeHelper('generic');

/**
 * Storage pin countdown that is used to save pin countdown data.
 * @returns {store2} The function refer to https://www.npmjs.com/package/store2.
 */
const pinCountdownStorage = storeHelper('pin_countdown');

export {
  storeHelper,
  authStorage,
  kycStorage,
  communityStorage,
  mutualFundStorage,
  transactionStorage,
  genericStorage,
  pinCountdownStorage,
};
